import React from "react";

function Icon(data) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={data.w} height={data.h}>
          <path d="M7 39V14.35 39Zm0 3q-1.2 0-2.1-.9Q4 40.2 4 39V14.35q0-1.2.9-2.1.9-.9 2.1-.9h9.5V7q0-1.15.9-2.075Q18.3 4 19.5 4h9q1.2 0 2.1.925.9.925.9 2.075v4.35H41q1.2 0 2.1.9.9.9.9 2.1v11.9q-.7-.55-1.425-1-.725-.45-1.575-.85V14.35H7v24.675V39h16.7q.2.8.5 1.55t.7 1.45Zm12.5-30.65h9V7h-9ZM36 45.65q-3.95 0-6.8-2.85-2.85-2.85-2.85-6.8 0-3.95 2.85-6.8 2.85-2.85 6.8-2.85 3.95 0 6.8 2.85 2.85 2.85 2.85 6.8 0 3.95-2.85 6.8-2.85 2.85-6.8 2.85Zm3.7-4.6 1.35-1.35-4.2-3.8v-6.2h-2.1v6.8Z" />
        </svg>
    );
  }

export default Icon;
